import React, { useState } from 'react';
import Update_jobs_status from './../Pop_up/Update_jobs_status';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
const Associated_job = (props) => {
  const {
    buttonLabel,
    className
  } = props;

  const [modal, setModal] = useState(false);
  const [nestedModal, setNestedModal] = useState(false);
  const [closeAll, setCloseAll] = useState(false);

  const toggle = () => setModal(!modal);
  const toggleNested = () => {
    setNestedModal(!nestedModal);
    setCloseAll(false);
  }
  const toggleAll = () => {
    setNestedModal(!nestedModal);
    setCloseAll(true);
  }

  return (
    <>
    <i onClick={toggle} className="fa fa-plus" Title="Associated Job"></i>
      <Modal id="filter_model_cont" isOpen={modal} toggle={toggle} className={className} className="nested_model">
        <ModalHeader toggle={toggle}>Associated Job </ModalHeader>

          <ModalBody>
            
<div className="form-inner-box">
<div className="form_search_lits">					
<input type="text" className="jobPost_model"/>
<span className="jobpost_seh_icon">
<i className="fa fa-search"></i>
</span>
</div>
</div>

<div className="interview_section">
<table className="table-bordered table">
<thead>
<tr>
<th>Job Opening ID</th>
<th>Posting Title</th>
<th>Target Date</th>
<th>Job Opening Status</th>
<th>Client Name</th>
<th>Assigned Recuriter(s)</th>
</tr>
</thead>
<tbody>
<tr>
<td><input type="radio" /> 12345 </td>
<td>Senior Manager</td>
<td>Mar 22 , 2020</td>
<td className="updatestatus">Waiting for Approval <span><Update_jobs_status/></span></td>
<td>Paul</td>
<td>Sanjeev</td>
</tr>
</tbody>

</table>
</div>
            
            </ModalBody>
            <ModalFooter>
              <Button color="btn btn-outline-primary" onClick={toggle}>Close</Button>{' '}
            </ModalFooter>
          </Modal>
    </>
  );
}

export default Associated_job;